import cn from 'classnames';

//Types
import { ILinkedInAuthBtn } from '~components/LinkedInAuthBtn/types';
import { AuthLoadingState } from '~context/auth/types';
//Components
import LinkedIn from './LinkedIn';
import LinkedInBtn from '~components/LinkedInAuthBtn/LinkedInBtn';
//Constants
import { LINKEDIN_CLIENT_ID, URL_ORIGIN } from '~config/constants';
//GraphQL
import { useLinkedinLoginMutation } from '~graphqlResources';
//Context
import { useAuthContext } from '~context/auth';
//Config
import {linkedInRoute} from '~config/routes';
//Hooks
import {useCommonModals} from '~context/commonModals';



interface ILinkedInRenderElementProps {
    onClick(): void
    disabled: boolean
}

export default function LinkedInAuthBtn({title, className, onAuthFail, onAuthSuccess}: ILinkedInAuthBtn) {
    const {login, setAuthLoadingState} = useAuthContext();
    const {openErrorModal} = useCommonModals();

    const [linkedinLogin, {loading: mutationLoading}] = useLinkedinLoginMutation({
        update(_, {data: {loginBySocialToken: {profile, jwt}}}) {
            if (jwt?.token && profile) {
                login({profile, jwt});
                onAuthSuccess({profile, jwt});
            }
        },
        onError(err) {
            onAuthFail(err);
            setAuthLoadingState(AuthLoadingState.FAILED);
        }
    });

    const responseSuccessLinkedin = (response: any) => {
        if (response?.code) {
            setAuthLoadingState(AuthLoadingState.PENDING);

            linkedinLogin({
                variables: {
                    token: response.code,
                    callback: `${URL_ORIGIN}${linkedInRoute}`
                }
            });
        } else {
            setAuthLoadingState(AuthLoadingState.FAILED);
            openErrorModal({
                modalBody: 'Linkedin code is missing in linkedin response',
                reportData: {
                    error: new Error('Linkedin code is missing in linkedin response'),
                    errorScope: 'Linkedin Authentication',
                    extraData: response
                }
            });
        }
    };

    const responseErrorLinkedin = (error: any) => {
        setAuthLoadingState(AuthLoadingState.FAILED);
        // eslint-disable-next-line no-console
        console.log('Linkedin auth fail', error);
    };

    if (!LINKEDIN_CLIENT_ID) return null;

    return (
        <div className={cn(className)}>
            <LinkedIn
                clientId={LINKEDIN_CLIENT_ID}
                onFailure={responseErrorLinkedin}
                onSuccess={responseSuccessLinkedin}
                scope="r_liteprofile,r_emailaddress"
                redirectUri={`${URL_ORIGIN}${linkedInRoute}`}
                disabled={mutationLoading}
                renderElement={(renderProps: ILinkedInRenderElementProps) => {
                    const onClick = () => {
                        setAuthLoadingState(AuthLoadingState.PENDING);
                        setTimeout(renderProps.onClick, 400);
                    };

                    return (
                        <LinkedInBtn title={title} onClick={onClick} disabled={renderProps.disabled}/>
                    );
                }}
            />
        </div>
    );
}
